// extracted by mini-css-extract-plugin
module.exports = {"container":"aShvNRnEZY62KAFf6R8SG"};